import convertToArray from './convertToArray';
import StopScroll from './StopScroll';

class SettingInvoice {
  init() {
    this.doc = document;
    this.radioShopId = 'settingInvoiceAddressShop';
    this.radioCorpId = 'settingInvoiceAddressCorporation';
    this.radioOtherId = 'settingInvoiceAddressOther';
    this.shop = this.doc.getElementById('shop');
    this.shopActiveClass = 'is_active';
    this.corporation = this.doc.getElementById('corporation');
    this.corpActiveClass = 'is_active';
    this.other = this.doc.getElementById('other');
    this.otherActiveClass = 'is_active';
    this.submitBtn = this.doc.getElementById('submitBtn');
    this.sendDialog = this.doc.getElementById('sendDialog');
    this.sendDialogActiveClass = 'is_active';
    this.closeSendBtnAttr = 'data-close-send-btn';
    this.closeSendBtn = convertToArray(this.doc.querySelectorAll(`[${this.closeSendBtnAttr}]`));
    this.closeSendBtnLen = this.closeSendBtn.length;
    this.backdrop = this.doc.getElementById('backdrop');
    this.backdropActiveClass = 'is_active';
    this.switchArea = this.switchArea.bind(this);
    this.submit = this.submit.bind(this);
    this.closeSend = this.closeSend.bind(this);
    this.stopScroll = new StopScroll();
  }
  start() {
    this.areaRadioBtnName = 'invoiceAddressRadioBtn';
    this.areaRadioBtn = convertToArray(document.querySelectorAll(`input[name='${this.areaRadioBtnName}']`));
    this.areaRadioBtnLen = this.areaRadioBtn.length;
    if (!this.areaRadioBtnLen) return;
    this.init();
    for (let ri = 0; ri < this.areaRadioBtnLen; ri += 1) {
      this.areaRadioBtn[ri].addEventListener('change', this.switchArea);
    }
    this.submitBtn.addEventListener('click', this.submit);
  }
  switchArea(e) {
    const current = e.target;
    const currentId = current.id;
    if (currentId === this.radioShopId) {
      this.switchShop();
    } else if (currentId === this.radioCorpId) {
      this.switchCorp();
    } else {
      this.switchOther();
    }
  }
  switchShop() {
    this.corporation.classList.remove(this.corpActiveClass);
    this.other.classList.remove(this.otherActiveClass);
    this.shop.classList.add(this.shopActiveClass);
    this.submitBtn.disabled = true;
  }
  switchCorp() {
    this.shop.classList.remove(this.shopActiveClass);
    this.other.classList.remove(this.otherActiveClass);
    this.corporation.classList.add(this.corpActiveClass);
    this.submitBtn.disabled = false;
  }
  switchOther() {
    this.shop.classList.remove(this.shopActiveClass);
    this.corporation.classList.remove(this.corpActiveClass);
    this.other.classList.add(this.otherActiveClass);
    this.submitBtn.disabled = false;
  }
  submit() {
    this.sendDialog.classList.add(this.sendDialogActiveClass);
    this.backdrop.classList.add(this.backdropActiveClass);
    for (let bi = 0; bi < this.closeSendBtnLen; bi += 1) {
      this.closeSendBtn[bi].addEventListener('click', this.closeSend);
    }
    this.backdrop.addEventListener('click', this.closeSend);
    this.stopScroll.stop();
  }
  closeSend(e) {
    e.preventDefault();
    this.sendDialog.classList.remove(this.sendDialogActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    for (let bi = 0; bi < this.closeSendBtnLen; bi += 1) {
      this.closeSendBtn[bi].removeEventListener('click', this.closeSend);
    }
    this.backdrop.removeEventListener('click', this.closeSend);
    this.stopScroll.reStart();
  }
}
export default SettingInvoice;



// WEBPACK FOOTER //
// ./src/js/module/SettingInvoice.js